import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { canAddToCart } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export function xcCanAddToCart(
    state: ApplicationState,
    product: ProductModel,
    productInfo?: ProductInfo,
    configurationCompleted?: boolean,
    variantSelectionCompleted?: boolean,
    configurationSelection?: SafeDictionary<string>,
) {
    // Special Order Products
    if (product.detail?.isSpecialOrder || !showPrice(productInfo) || isAddToCartRevoked(productInfo)) {
        return false;
    }

    return canAddToCart(
        state,
        product,
        productInfo,
        configurationCompleted,
        variantSelectionCompleted,
        configurationSelection,
    );
}

export function isAddToCartRevoked(productInfo?: ProductInfo) {
    return getInventoryAdditionalResultIsTrue("disableAddToCart", productInfo) || !showPrice(productInfo);
}

export function showPrice(productInfo?: ProductInfo) {
    if (productInfo?.pricing?.unitNetPrice === 0) {
        return false;
    }

    if (getInventoryAdditionalResultIsTrue("hidePrice", productInfo)) {
        return false;
    }

    return true;
}

export function showInventoryBasedOnAvailability(productInfo?: ProductInfo) {
    if (isAddToCartRevoked(productInfo)) {
        if (getInventoryAdditionalResultIsTrue("hideInventory", productInfo)) {
            return false;
        }
    }
    return true;
}

function getInventoryAdditionalResultIsTrue(key: string, productInfo?: ProductInfo) {
    if (productInfo?.inventory?.additionalResults != null) {
        return productInfo.inventory.additionalResults[key];
    }
}
